import { IGroup } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import ActividadLineaBaseService from "../../services/LineaBase/ActividadLineaBaseService";
import {
  IActividad,
  IActividadTable,
  IListaActividadesPorProceso,
} from "../../Interfaces/LineaBase/IProcesos";

export const useActividadesPorGrupo = () => {
  const [data, setData] = useState<IListaActividadesPorProceso[]>([]);

  const postActividades = () => {
    ActividadLineaBaseService.postListarActividadesLineaBase({
      procesoLineaBaseId: "deea1ba4-6550-4dbc-8b9e-72b6da823b0e",
    }).then((res) => {
      if (res.status === 200) {
        setData(res.data);
      }
    });
  };
  useEffect(() => {
    postActividades();
  }, []);

  return { data };
};
